import { render } from "./FavSupplierListPage.vue?vue&type=template&id=38d83f86&scoped=true&lang=html"
import script from "./FavSupplierListPage.vue?vue&type=script&lang=js"
export * from "./FavSupplierListPage.vue?vue&type=script&lang=js"

import "./FavSupplierListPage.vue?vue&type=style&index=0&id=38d83f86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d83f86"]])

export default __exports__